export const ACCEPTED_FILE_TYPES = {
  PDF: ["application/pdf"],
} as const;
